import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { usePatentCreate } from '@/module/Author/Patent/model/PatentQuery';
import { PatentSchema, defaultPatentValues, patentSchema } from '@/module/Author/Patent/model/PatentSchema';

import { useAppNotification } from '@feature/utils';

import { PatentForm } from './PatentForm';

export function PatentCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = usePatentCreate();

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: PatentSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newPatent => {
        notification.success();
        navigate({ to: '/author/patent/$patentId', params: { patentId: String(newPatent.id) } });
      },
    });
  };

  return (
    <PatentForm
      title={t('patents.form.title.create')}
      schema={patentSchema}
      defaultValues={defaultPatentValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
